/* eslint-disable camelcase */ 

type Locale = 'en' | 'es';

type Phrase = (l: Locale) => string;

export const i18n_connect_and_grow_with_top_instructors: Phrase =locale => {
  const en = `Connect and Grow with Top Instructors`;
  const phrases: { [key: string]: undefined | string } = {
    en, 
    es: `Conecta y crece junto a nuestros mejores maestros.`,
  };
  return phrases[locale] || en;
};
            